import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import { SlotStatus } from "../constants/slotStatus";

export const SlotButtons = ({
  name = "",
  title = "",
  timeSlots = [],
  handleOnClick = () => {},
  selectedSlot = null,
  errorMsg,
  isMandatory = true,
  isManager = false,
  emptyMessage = "No slots more for today.",
}) => {
  return (
    <div className="wrapper">
      <label className="form-label">
        {title}
        {isMandatory && <span className="mandatory-field">*</span>}
      </label>
      <div className="slots-field">
        {timeSlots
          ? timeSlots.length < 1
            ? emptyMessage
            : timeSlots?.map((slots) => (
                <Button
                  key={slots.slotTitle}
                  className={`slots-button ${
                    selectedSlot === slots.slotTitle
                      ? "selected"
                      : !(
                          slots.slotStatus === SlotStatus.NEW ||
                          slots.slotStatus === SlotStatus.LIMITEDQUANTITY ||
                          isManager
                        )
                      ? "unselectable-slots"
                      : ""
                  }`}
                  name={name}
                  onClick={(event) =>
                    slots.slotStatus === SlotStatus.NEW ||
                    slots.slotStatus === SlotStatus.LIMITEDQUANTITY ||
                    isManager
                      ? handleOnClick(event, slots)
                      : handleOnClick(event, {})
                  }
                >
                  {slots.slotTitle}
                  <br />
                  {slots.startTime && slots.endTime
                    ? `${slots.startTime} - ${slots.endTime}`
                    : ""}
                  <span
                    className={`slots-button-span ${slots.slotStatus}-slots-button-span`}
                  >
                    {SlotStatus.getStatusValue(slots.slotStatus)}
                  </span>
                </Button>
              ))
          : "Please select date first."}
      </div>
      {errorMsg && <span className="error-message">{errorMsg}</span>}
    </div>
  );
};

SlotButtons.propTypes = {
  name: PropTypes.string,
  title: PropTypes.string,
  timeSlots: PropTypes.array,
  handleOnClick: PropTypes.func,
  selectedSlot: PropTypes.string,
  errorMsg: PropTypes.any,
};
